<ul class="lightrope">
    @for (bulb of bulbs; track bulb) {
        <li></li>
    }
</ul>
